import { NavLink, useLocation } from 'react-router-dom';
import { Film, Home, Popcorn, UserRound } from 'lucide-react';
import { useAuth } from '../context/AuthProvider';
import { isNativePlatform } from '../lib/runtime';
import { hapticSelection } from '../lib/haptics';
import { cn } from '../lib/utils';

/** Discover stays on Home CTA — tab bar prioritizes Account/profile access. */
const TABS = [
  { to: '/', label: 'Home', icon: Home, end: true },
  { to: '/watchlist', label: 'Watchlist', icon: Popcorn, end: false },
  { to: '/watched', label: 'Watched', icon: Film, end: false },
  { to: '/account', label: 'Account', icon: UserRound, end: false },
] as const;

const HIDDEN_PREFIXES = [
  '/privacy',
  '/terms',
  '/email-confirmed',
  '/reset-password',
];

/** Native-only bottom nav for signed-in core destinations. Hidden on web. */
export function NativeBottomNav() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (!isNativePlatform() || !user) return null;
  if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    return null;
  }

  return (
    <nav
      aria-label="Main"
      className="native-tab-bar fixed inset-x-0 bottom-0 z-50 border-t border-white/[0.08] bg-[#120709]/95 backdrop-blur-xl md:hidden"
    >
      <ul className="mx-auto flex max-w-lg items-stretch justify-around px-1 pt-1">
        {TABS.map(({ to, label, icon: Icon, end }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={end}
              onClick={() => {
                void hapticSelection();
              }}
              className={({ isActive }) =>
                cn(
                  'flex min-h-[48px] flex-col items-center justify-center gap-0.5 px-1 text-[10px] font-medium tracking-wide transition-colors',
                  isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
                )
              }
            >
              {({ isActive }) => (
                <>
                  <Icon
                    className={cn('h-5 w-5', isActive && 'drop-shadow-[0_0_8px_hsl(39_92%_57%/0.45)]')}
                    strokeWidth={isActive ? 2.25 : 1.75}
                    aria-hidden
                  />
                  <span>{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
